export const AUTH_PROVIDER_KEY = 'vf_bifrost_auth_provider';
